import ApiService from '../../../services/apiService';
import { mapMutations, mapState } from 'vuex';
import get from 'lodash/get';
import listMixin from '../assetMgmt/listMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISFMAccessMgmt',
  mixins: [listMixin, userItemsPerListMixin],
  data: function () {
    return {
      selected: [],
      tableOptions: {
        ...defaultTableOptions
      },
      fab: false,
      search: null,
      dialog: false,
      tableLoading: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      buttons: [{
        title: this.$i18n_t('Common.create'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.disabled
      }],
      items: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: '',
          value: 'icon'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.id'),
          value: 'id'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.firstName'),
          value: 'user.firstName'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.lastName'),
          value: 'user.lastName'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.email'),
          value: 'user.email'
        }, {
          sortable: true,
          text: this.$i18n_t('IS.FM.AccessMgmt.building'),
          value: 'dtwinData.title'
        }, {
          sortable: true,
          text: this.$i18n_t('IS.FM.AccessMgmt.accObjct'),
          value: 'accessObjectData.title'
        }, {
          sortable: false,
          text: this.$i18n_t('IS.FM.AccessMgmt.Restrictions'),
          value: 's'
        }, {
          sortable: false,
          text: '',
          value: '',
          align: 'right'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted() {
    this.$store.state.app.loading = false;
    this.fetchIsFmAccessMgmt();
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    keyRigthsIcon(keys) {
      keys.forEach(key => {
        var icons = [];
        if (key.data.dateFrom || key.data.dateTo) {
          icons.push({
            icon: 'fal fa-calendar-alt',
            tooltip: this.$i18n_t('IS.FM.AccessMgmt.date')
          });
        }
        if (key.data.days.length) {
          icons.push({
            icon: 'fal fa-calendar-day',
            tooltip: this.$i18n_t('IS.FM.AccessMgmt.weekDays')
          });
        }
        if (key.data.timeFrom || key.data.timeTo) {
          icons.push({
            icon: 'fal fa-watch',
            tooltip: this.$i18n_t('IS.FM.AccessMgmt.timeWindow')
          });
        }
        if (key.data.usagePerWeek && key.data.usagePerWeek !== '0') {
          icons.push({
            icon: 'fal fa-calendar-week',
            tooltip: this.$i18n_t('IS.FM.AccessMgmt.usagePerWeek')
          });
        }
        key.icons = icons;
      });
    },
    keyTwinTitle(item) {
      return `${get(item, 'dtwinData.title')} (${get(item, 'parentData.title')})`;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    addItem() {
      this.dialog = true;
    },
    fetchIsFmAccessMgmt() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      ApiService.isFmAccessFetch(this).then(data => {
        this.items = data;
        this.keyRigthsIcon(this.items);
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
        this.tableLoading = false;
      });
    },
    deleteItem(item) {
      confirm(this.$i18n_t('Common.areYouSure')) && this.deleteToDB(item);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save(data) {
      if (this.editedIndex > -1) {
        this.updateToDB(data);
      } else {
        this.saveToDB(data);
      }
      this.close();
    },
    saveToDB(item) {
      this.tableLoading = true;
      ApiService.isFmAccessCreate(item).then(() => {
        this.$snack(this.$i18n_t('IS.FM.AccessMgmt.accessObjectSaved'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.AccessMgmt.errorObjectSave'), 'error');
        }
      }).finally(() => {
        this.fetchIsFmAccessMgmt();
      });
    },
    updateToDB(item) {
      this.tableLoading = true;
      ApiService.isFmAccessUpdate(item).then(() => {
        this.$snack(this.$i18n_t('IS.FM.AccessMgmt.accessObjectSaved'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.AccessMgmt.errorObjectSave'), 'error');
        }
      }).finally(() => {
        this.fetchIsFmAccessMgmt();
      });
    },
    deleteToDB(item) {
      this.tableLoading = true;
      ApiService.isFmAccessDelete(item.id).then(() => {
        this.$snack(this.$i18n_t('IS.FM.AccessMgmt.accessObjectDel'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('IS.FM.AccessMgmt.errorObjectDel'), 'error');
        }
      }).finally(() => {
        this.fetchIsFmAccessMgmt();
      });
    }
  }
};